module.exports = __webpack_public_path__ + "static/media/sidebar-2.143b0654.jpg";